import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Slider from 'react-slick';
import { AsyncImage } from 'loadable-image';
import ApiService from '../Service/ApiService';
import './NewsImageGallery.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import newsGalleryData from '../../data/newsImage.json';

const NewsImageGallery = ({ isAlbanian, newsId }) => {
  const sliderRef = useRef(null);
  const modalSliderRef = useRef(null);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [projects, setProjects] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
      if (!newsId) return;
  
      // Filtrimi i imazheve vetëm për këtë projectId
      const filteredImages = newsGalleryData.filter(
        (img) => String(img.news_id) === String(newsId)
      );
  
      setProjects(filteredImages);
    }, [newsId]);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(window.innerWidth < 576 ? 1 : 2);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

   useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === 'ArrowLeft') {
          if (isModalOpen) {
            modalSliderRef.current?.slickPrev();
          } else {
            sliderRef.current?.slickPrev();
          }
        } else if (event.key === 'ArrowRight') {
          if (isModalOpen) {
            modalSliderRef.current?.slickNext();
          } else {
            sliderRef.current?.slickNext();
          }
        }
      };
  
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isModalOpen]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    centerMode: true, 
    centerPadding: "0px", 
    arrows: false,
    swipe: true,
    touchThreshold: 10,
    draggable: true,
    adaptiveHeight: true,
  };

  const modalSettings = {
    ...settings,
    slidesToShow: 1,
    initialSlide: currentSlide,
    beforeChange: (_, next) => setCurrentSlide(next),
  };

  const openModal = (index) => {
    setCurrentSlide(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const handleNavigate = (newsId) => {
    if (newsId) {
      window.location.href = `/newsdetails/${newsId}`;
    } else {
      console.error("Project ID is null or undefined");
    }
  };

  return (
    <div>
      <div className="newsimagegallery-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          {projects.length > 0 && projects[0].prev && (
      <button 
        className="newsimagegallery-prev-button-outside" 
        onClick={() => handleNavigate(projects[0].prev)}
      >
       <img src="/prev.png" alt="Prev" className="newsimagegallery-prevPro-btn-img"/>
      </button>
    )}
    {projects.length > 0 && projects[0].next && (
      <button 
        className="newsimagegallery-nextBottom-button-outside" 
        onClick={() => handleNavigate(projects[0].next)}
      >
       <img src="/next.png" alt="Next" className="newsimagegallery-nextProBottom-btn-img"/>
      </button>
    )}
          
          
          
          <div className="newsimagegallery-paragraph">
          <div className='newsimagegallery-things-above-image'>
          <div className="newsimagegallery-title">{isAlbanian ? 'GALERIA' : 'GALLERY'}</div>
          <div className="newsimagegallery-top-right-buttons">
            <button className="newsimagegallery-circle-button" onClick={() => sliderRef.current.slickPrev()}>
            <img src="/b.png" alt="close" className="newsimagegallery-xCircle-btn-img"/>
            </button>
            <button className="newsimagegallery-circle-button" onClick={() => sliderRef.current.slickNext()}>
            <img src="/n.png" alt="close" className="newsimagegallery-xCircle-btn-img"/>
            </button>
          </div>
          </div>
            <Slider ref={sliderRef} {...settings}>
              {projects.map((project, index) => (
                <div key={project.news_image_id} className="newsimagegallery-carousel-slide">
                  <div className="newsimagegallery-carousel-image-container">
                    <AsyncImage
                      src={project.news_image_url}
                      alt={`Project ${project.news_image_id}`}
                      onClick={() => openModal(index)}
                      className="newsimagegallery-carousel-image"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>

      {isModalOpen && (
        <div className="newsimagegallery-modal-overlay" onClick={closeModal}>
          <div className="newsimagegallery-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className='newsimagegallery-modal-close-position'>
            <button className="newsimagegallery-modal-close-button" onClick={closeModal}>
            <img src="/x.png" alt="close" className="newsimagegallery-xClose-btn-img"/>
            </button>
            </div>
            <div className="newsimagegallery-modal-navigation">
              <button className="newsimagegallery-modal-nav-button left" onClick={() => modalSliderRef.current.slickPrev()}>
              <img src="/b.png" alt="close" className="newsimagegallery-xClose-btn-img"/>
              </button>
              <button className="newsimagegallery-modal-nav-button right" onClick={() => modalSliderRef.current.slickNext()}>
              <img src="/n.png" alt="close" className="newsimagegallery-xClose-btn-img"/>
              </button>
            </div>
            <Slider ref={modalSliderRef} {...modalSettings}>
              {projects.map((project) => (
                <div key={project.news_image_id} className="newsimagegallery-modal-slide">
                  <img
                    src={project.news_image_url}
                    alt={`Project ${project.news_image_id}`}
                    className="newsimagegallery-modal-image"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsImageGallery;
